



const imageInput = document.getElementById('imageInput') as HTMLInputElement;
const imagePreview = document.getElementById('image-preview') as HTMLImageElement;
const statusText = document.getElementById('status') as HTMLParagraphElement;
const resultsDiv = document.getElementById('results') as HTMLDivElement;
const debugLog = document.getElementById('debugLog') as HTMLTextAreaElement;

function logToPage(message: string): void {
    const timestamp = new Date().toLocaleTimeString();
    debugLog.innerHTML += `[${timestamp}] ${message}\n`;
    debugLog.scrollTop = debugLog.scrollHeight;
}

logToPage('Application initialized.');
statusText.textContent = 'Ready to scan.';

imageInput.addEventListener('change', (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files[0]) {
        const file = target.files[0];
        imagePreview.src = URL.createObjectURL(file);
        scanCard(file);
    }
});

async function scanCard(imageFile: File): Promise<void> {
    resultsDiv.innerHTML = '';
    statusText.textContent = 'Uploading and scanning image...';
    logToPage('Sending image to server for processing.');

    const formData = new FormData();
    formData.append('image', imageFile);

    try {
        const response = await fetch('/pkms/api/v2/scan-fast', {
            method: 'POST',
            body: formData,
        });

        let data: any;
        try {
            data = await response.json();
        } catch (e) {
            // Fallback for non-JSON errors (e.g. 500 HTML page)
            const text = await response.text();
            throw new Error(`Server error (${response.status}): ${text.substring(0, 100)}...`);
        }

        if (!response.ok) {
            const errorMsg = data.error || 'Unknown server error';
            logToPage(`Error from server: ${errorMsg}`);
            statusText.textContent = errorMsg;

            // Render debug info if available (CRITICAL for debugging 404s)
            if (data.debug) {
                resultsDiv.innerHTML = generateDebugHtml(data.debug);
            }
            return; // Stop processing
        }

        logToPage('Received response from server.');

        // Handle success case
        if (data.card && data.card.name) {
            logToPage(`Found card: "${data.card.name}" (Confidence: ${(data.confidence * 100).toFixed(0)}%)`);
            statusText.textContent = `Found: ${data.card.name}`;
            displayCardInfo(data);
        } else {
            logToPage(`Unexpected response format: ${JSON.stringify(data).substring(0, 200)}`);
            statusText.textContent = 'Could not identify the card.';
        }
    } catch (error) {
        logToPage(`Error scanning card: ${error}`);
        statusText.textContent = 'Failed to scan card.';
    }
}

async function fetchCardData(name: string, number: string): Promise<void> {
    const query = `name:"${name}" number:"${number}"`;
    const API_URL = `https://api.pokemontcg.io/v2/cards?q=${encodeURIComponent(query)}`;

    logToPage(`Querying API: ${API_URL}`);

    try {
        const response = await fetch(API_URL);
        const data = await response.json();
        if (data.data && data.data.length > 0) {
            logToPage("Card data found!");
            // Wrap in expected structure for displayCardInfo
            displayCardInfo({ card: data.data[0] });
        } else {
            logToPage(`No exact match found for Name: "${name}" and Number: "${number}".`);
            statusText.textContent = `No data found for ${name} (${number}).`;
        }
    } catch (error) {
        logToPage(`API fetch error: ${error}`);
        statusText.textContent = 'Failed to fetch card data.';
    }
}

function displayCardInfo(data: any): void {
    const card = data.card;
    statusText.textContent = "Card identified!";

    // Safely handle set information using the dedicated set object from API if available
    const setName = data.set?.name || card.set?.name || card.set_name || 'Unknown';
    const setTotal = data.set?.totalCards ? `/${data.set.totalCards}` : '';

    // Pricing URL
    let pricingHtml = '';
    if (data.pricing?.priceChartingUrl) {
        pricingHtml = `<p><strong>PriceCharting:</strong> <a href="${data.pricing.priceChartingUrl}" target="_blank">View Prices</a></p>`;
    }

    const releaseDate = card.set?.releaseDate ? new Date(card.set.releaseDate) : null;
    const age = releaseDate ? new Date().getFullYear() - releaseDate.getFullYear() : 'Unknown';
    const marketPrice = card.tcgplayer?.prices?.holofoil?.market || card.tcgplayer?.prices?.normal?.market || 'N/A';
    const trendPrice = card.tcgplayer?.prices?.holofoil?.trendPrice || card.tcgplayer?.prices?.normal?.trendPrice || 'N/A';

    const debugHtml = data.debug ? generateDebugHtml(data.debug) : '';

    resultsDiv.innerHTML = `
        <p><strong>Name:</strong> ${card.name}</p>
        <p><strong>Set:</strong> ${setName} <span style="color: #666;">(${card.number || '?'}${setTotal})</span></p>
        ${pricingHtml}
        <p><strong>Age:</strong> ~${age} years old</p>
        <p><strong>Rarity:</strong> ${card.rarity || 'N/A'}</p>
        <p><strong>Market Price:</strong> ${marketPrice}</p>
        <p><strong>Market Price Trend:</strong> ${trendPrice}</p>
        ${debugHtml}
    `;
}

function generateDebugHtml(debug: any): string {
    return `
    <div style="margin-top: 20px; border-top: 1px solid #ccc; padding-top: 10px;">
        <details>
            <summary style="cursor: pointer; font-weight: bold; color: #555;">🛠 Debug Info (Click to expand)</summary>
            <div style="background: #f5f5f5; padding: 10px; margin-top: 10px; border-radius: 5px;">
                <p><strong>Detector:</strong> ${debug.detector || 'N/A'}</p>
                <p><strong>Rotation Used:</strong> ${debug.rotationUsed !== undefined ? debug.rotationUsed + '°' : 'N/A'}</p>
                <p><strong>Processing Time:</strong> ${debug.processingTimeMs || 0}ms</p>
                
                <div style="margin-top: 10px;">
                    <p><strong>1. Detection Overlay (What Python saw):</strong></p>
                    ${debug.overlayImage
            ? `<img src="data:image/jpeg;base64,${debug.overlayImage}" style="max-width: 100%; border: 2px dashed #999; border-radius: 4px;">`
            : '<em>No overlay available</em>'}
                </div>

                <div style="margin-top: 10px;">
                    <p><strong>2. OCR Input (What Tesseract read):</strong></p>
                    ${debug.croppedImage
            ? `<img src="data:image/jpeg;base64,${debug.croppedImage}" style="max-width: 100%; border: 2px solid red; border-radius: 4px;">`
            : '<em>No crop available</em>'}
                </div>
            </div>
        </details>
    </div>`;
}
